import React from "react";

export default function CityError() {
    return (
        <h5 className="text-secondary text-uppercase font-monospace justify-content-center d-flex w-100">
            Please type valid city name
        </h5>
    );
}
